

// import React, { useState } from "react";
// import RoutesComponent from "./Routes";
// const BlockedSite = () => {
//   const [hovered, setHovered] = useState(false);

//   return (
//     <div className="neterror">
//       <div
//         className="icon-wrapper"
//         onMouseEnter={() => setHovered(true)}
//         onMouseLeave={() => setHovered(false)}
//       >
//         <div className="icon icon-generic" />
//         {hovered && (
//           <div className="message">
//             <p>
//               <strong>{window.location.hostname}</strong> refused to connect.
//             </p>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// function App() {

//   // 👉 iframe block
//   if (window !== window.top) {
//     return <BlockedSite />;
//   }

//   // 👉 normal site load
//   return (
//     <>
//       <RoutesComponent />
//     </>
//   );
// }

// export default App;
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import RoutesComponent from "./Routes";
import { destroySessionManager, initSessionManager } from "./CommonUtils/SessionManager";
function App() {
  const navigate = useNavigate();

  useEffect(() => {
    console.log("🚀 App Mounted");

    initSessionManager(() => {
      console.log("🚪 Forced Logout Triggered");
      sessionStorage.clear();
      navigate("/");
    });

    return () => {
      destroySessionManager();
    };
  }, [navigate]);

  return <RoutesComponent />;
}

export default App;